import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Timeframe } from '../../model/timeframe';
import { Booking } from '../../model/booking';

@Component({
  selector: 'yard-time-frame-usage-column',
  standalone: false,
  templateUrl: './time-frame-usage-column.component.html',
  styleUrl: './time-frame-usage-column.component.scss',
})
export class TimeFrameUsageColumnComponent {

  timeframes: Timeframe;
  @Input('timeframes') set setTimeframes(value: Timeframe) {
    this.timeframes = value;
    this.lowerBound = value.index;
    this.upperBound = (value.index + 1) == 24 ? 0 : (value.index + 1);
  }

  lowerBound: number;
  upperBound: number;

  @Input() index: number;

  @Input() selectedTransportId: number;

  @Output() transportSelected = new EventEmitter<number>();

  public handleItemClick(booking: Booking) {
    if (booking && booking.transportId) {
      this.transportSelected.emit(booking.transportId);
    }
  }

}
